import React, { useState } from "react";
import "./Home.css";
import heic2any from "heic2any";
import miragelogo from "../../assets/Core/2.png";

const Home = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [convertedImage, setConvertedImage] = useState(null);
  const [format, setFormat] = useState("jpg");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      alert("Please upload an image file.");
    }
  };

  const handleConvert = async () => {
    if (!selectedFile) {
      alert("Please select an image file first.");
      return;
    }

    try {
      let convertedBlob;

      if (selectedFile.type === "image/heic") {
        convertedBlob = await heic2any({
          blob: selectedFile,
          toType: `image/${format}`,
        });
      } else {
        const imageBitmap = await createImageBitmap(selectedFile);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = imageBitmap.width;
        canvas.height = imageBitmap.height;
        ctx.drawImage(imageBitmap, 0, 0);

        canvas.toBlob((blob) => {
          setConvertedImage(URL.createObjectURL(blob));
        }, `image/${format}`);
        return;
      }

      const imageURL = URL.createObjectURL(convertedBlob);
      setConvertedImage(imageURL);
    } catch (error) {
      console.error("Conversion error:", error);
      alert("Failed to convert the image.");
    }
  };

  const handleDownload = () => {
    if (!convertedImage) return;

    const link = document.createElement("a");
    link.href = convertedImage;
    link.download = `converted.${format}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="home-main">
      <div className="home-container">
        <div className="home-main-top-container">
          <img className="home-logo-image" alt="logo" src={miragelogo} />
          <h1>Universal Image Converter</h1>
        </div>
        <div className="home-main-input-container">
          <input type="file" accept="image/*" onChange={handleFileChange} />
          <select onChange={(e) => setFormat(e.target.value)} value={format}>
            <option value="jpg">JPG</option>
            <option value="png">PNG</option>
            <option value="jpeg">JPEG</option>
            <option value="webp">WEBP</option>
            <option value="bmp">BMP</option>
          </select>
          {convertedImage ? (
            <button onClick={handleDownload}>Download</button>
          ) : (
            <button onClick={handleConvert}>Convert</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;

// This code now supports converting any image format (like JPG, PNG, BMP, WEBP, and even HEIC) to any chosen format. Let me know if you want any adjustments or more features! 🚀
